import login from './login';

export default {
  language: 'bg',
  country: 'bg',
  name: 'Български',
  embeddedLocale: login,
};
